import React, { useEffect, useRef, useState } from "react";
import {
  Container,
  RightContainer,
  Title,
  DescriptionInput,
  DescriptionText,
} from "./styled.js";
import DescriptionIcon from "@mui/icons-material/TextSnippetOutlined";
import BottomButtonGroup from "../../../Pages/BoardPage/BoardComponents/BottomButtonGroup/BottomButtonGroup.js";
import { useDispatch, useSelector } from "react-redux";
import { addQuantidadeOs } from "../../../../Services/cardService.js";

const QuantidadeOS = () => {
  const thisCard = useSelector((state) => state.card);

  const dispatch = useDispatch();
  const [inputFocus, setInputFocus] = useState(false);
  const [quantidadeOS, setQuantidadeOS] = useState(thisCard.quantidadeOS);
  const ref = useRef();
  const ref2 = useRef();

  const handleSaveClick = async () => {
    setInputFocus(false);
    await addQuantidadeOs(
      thisCard.cardId,
      thisCard.listId,
      thisCard.boardId,
      quantidadeOS,
      dispatch
    );
  };

  useEffect(() => {
    setQuantidadeOS(thisCard.quantidadeOS);
  }, [thisCard.quantidadeOS]);

  useEffect(() => {
    if (inputFocus) {
      ref.current.focus();
    }
  }, [inputFocus]);

  const handleClickOutside = (event) => {
    if (ref2.current && !ref2.current.contains(event.target)) {
      setInputFocus(false);
      setQuantidadeOS(thisCard.quantidadeOS);
    } else {
      setInputFocus(true);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  });

  return (
    <Container ref={ref2}>
      <DescriptionIcon fontSize="small" />
      <RightContainer>
        <Title>Quantidade OS</Title>
        {quantidadeOS && !inputFocus ? (
          <DescriptionText onClick={() => setInputFocus(true)}>
            {quantidadeOS}
          </DescriptionText>
        ) : (
          <DescriptionInput
            ref={ref}
            minHeight={inputFocus ? "5.5rem" : "2.5rem"}
            placeholder="Quant. OS..."
            value={quantidadeOS}
            onChange={(e) => setQuantidadeOS(e.target.value)}
          />
        )}
        <div style={{ display: inputFocus ? "block" : "none" }}>
          <BottomButtonGroup
            closeCallback={() => {
              setInputFocus(false);
              setQuantidadeOS(thisCard.quantidadeOS);
            }}
            clickCallback={handleSaveClick}
            title="Salvar"
          />
        </div>
      </RightContainer>
    </Container>
  );
};

export default QuantidadeOS;
